const colorScale = [
  [26, 152, 80],
  [102, 189, 99],
  [166, 217, 106],
  // [217, 239, 139],
  // [255, 255, 191],
  [254, 224, 139],
  [253, 174, 97],
  [244, 109, 67]
  // [215, 48, 39]
].map(([r, g, b]) => `rgb(${r},${g},${b})`);

const colorScaleMax = colorScale.length - 1;

export const defaultColor: string = 'rgb(255, 255, 191)';

export default (score: number): string => {
  const index = Math.round(
    colorScale.length - (score < 0 ? 0 : score) * colorScale.length
  );

  return colorScale[
    index > colorScaleMax ? colorScaleMax : index < 0 ? 0 : index
  ];
};
